<template>
   <div class="back-box">
    <div class="back-btn" @click="onBack">
        <i class="el-icon-arrow-left"></i>
    </div>
    <div class="back-center">
      <div class="back-nav" @click="onMessage">站内公告</div>
      <div class="back-nav" @click="onNews(6)">正品验证</div>
      <div class="back-nav" @click="onNews(4)">售前售后</div>
      <div class="back-nav" @click="onNews(7)">成为代理</div>
    </div>
    <div class="back-help">
    </div>
   </div>
</template>

<script>
export default {
  name: 'BackComponent',
  props: {
     to:{
       types: String,
       default: ''
     },
     title: {
        types: String,
        default: '909数码'
     }
   },
  data () {
    return {
    }
  },
  components: {
  },
  computed: {
  },
  methods: {
    onNews (id) {
      this.$router.push({name: 'news', query: {id: id}})
    },
    onMessage () {
      this.$router.push({name: 'message'})
    },
    onBack () {
      if (this.to) {
        this.$router.push({name: this.to})
      } else {
        this.$router.back(-1)
      }
      this.$emit('back')
    },
  },
  mounted: function () {
  }
}
</script>
<style lang="scss" scoped>
.back-box {
  padding-top: 8px;
  padding-left: 5px;
  padding-bottom: 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: #ff0000;
  color: #ffffff;
  align-items: center;
  .back-btn,.back-help {
    width: 50px;
  }
  .back-btn {
    font-size: 18px;
    font-weight: bold;
  }
  .back-center {
    font-size: 16px;
    font-weight: bold;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  }
}
</style>
